<template lang="pug">
  .card-container
    .card-index
      .header
        img(src="../../../public/images/card/header.jpg")
      .form-area
        el-form
          el-form-item
            el-input(type="text", placeholder="请输入姓名", v-model="form.cardName")
          el-form-item
            el-input(type="text", placeholder="请输入联系电话", v-model="form.receiverPhone")
          el-form-item
            el-input(type="text", placeholder="请输入身份证号", v-model="form.cardNo")
          el-form-item
            el-input#areaSelector(type="text", placeholder="请选择收货地区", readonly, v-model="areaText")
          el-form-item
            el-input(type="text", placeholder="请输入收货地址", v-model="form.receiverAdd")
          el-form-item(v-show="false")
            el-input(type="text", placeholder="选择收货地区后可选择号码", v-model="form.mobile", readonly, @focus="showMobileSelector")
          el-form-item
            el-button.btn-submit(:loading="loading", @click="handelSubmit") 免费办理
            .protocol
              el-checkbox(v-model="agreeProtocol") 我同意
              el-link(type="primary", @click="isProtocolShow = true") 《入网协议》
      .body
        img(src="../../../public/images/card/desc1.jpg")
        img(src="../../../public/images/card/desc2.jpg")
        img(src="../../../public/images/card/desc3.jpg")
        .card-notice
          img(src="../../../public/images/card/notice.jpg")
      el-dialog(:visible.sync="isProtocolShow", width="90%", top="10%")
        .protocol-content
          p
            | 中国移动通信客户服务协议
            br
            br 
            | 电&nbsp;信&nbsp;用&nbsp;户：（以下简称甲方）
            br 
            | 电信业务经营者：（以下简称乙方）
            br
            br 
            | 根据《中华人民共和国合同法》、《中华人民共和国消费者权益保护法》、《中华人民共和国网络安全法》、《全国人大常委会关于加强网络信息保护的决定》、《中华人民共和国电信条例》、《电信和互联网用户个人信息保护规定》、《电话用户真实身份信息登记规定》等法律法规的规定，甲方基于对乙方电信服务的了解和需求，自愿申请成为乙方用户。在平等、公平、诚信的基础上，双方达成如下协议：
            br
            | 第一条&nbsp;&nbsp;特别约定
            br 
            | 1.1&nbsp;本协议外乙方以通告、使用手册、宣传单页等形式公开做出的服务承诺，甲方办理业务时所签署的业务受理单、业务回执单、业务说明等表单均为本协议不可分割的一部分。双方以电子签名、电子印章形式签订的协议，与纸质协议具有同等法律效力。
            br
            | 1.2&nbsp;协议履行期间，如果发生网络调整或其他情形可能影响到甲方所使用的电信业务及服务时，乙方应当采用电话、短信、信函或电子邮件等方式提前通知甲方，如涉及众多用户，乙方除上述方式外可以采用广播、电视、报纸或互联网等方式进行公告。
            br
            | 1.3&nbsp;甲方应使用取得国家入网许可的终端设备。甲方自备的终端设备，如不具有支持甲方所选乙方提供服务的相应功能，甲方自行承担后果，并向乙方支付其所选服务的费用。
            br
            br
            | 第二条&nbsp;&nbsp;服务内容及服务承诺
            br
            | 2.1&nbsp;乙方承诺在现有技术条件下，在自身网络及与其签订有漫游协议的电信运营商的网络覆盖范围内为甲方提供电信服务。乙方承诺提供的电信服务,应当在其电信业务经营许可证载明的业务范围和有效期内，应当符合法律法规规定及政府主管部门发布的相关标准。
            br
            | 2.2&nbsp;乙方应通过营业厅、门户网站等渠道公示其业务种类、服务时限、资费标准、服务范围等内容。
            br
            | 2.3&nbsp;乙方向甲方提供便捷的业务咨询、办理和投诉受理渠道。
            br
            | 2.4&nbsp;甲方可自主选择是否订购第三方服务商提供的由乙方代收服务费的增值电信业务，具体业务内容及资费标准由第三方服务商负责告知甲方，乙方予以协助。
            br
            br
            | 第三条&nbsp;&nbsp;入网登记
            br
            | 3.1&nbsp;办理入网登记手续时，甲方必须按照国家法律法规的有关要求提交登记资料。
            br
            | 个人用户：甲方应出示个人有效证件原件，提供真实身份信息；
            br
            | 拒绝出示有效证件的，拒绝提供其证件上所记载身份信息的，冒用他人证件的，或者使用伪造、变造证件的，乙方有权拒绝为其办理入网手续。个人有效证件办理的业务，仅限个人或家庭使用。
            br
            | 3.2&nbsp;甲方入网登记身份信息发生变更，应及时到乙方指定的营业网点办理信息变更手续。
            br
            | 3.3入网后,&nbsp;系统随机生成或甲方自行设置用户初始服务密码。
            br
            br
            | 第四条&nbsp;&nbsp;资费方案
            br
            | 4.1&nbsp;甲方有权自主选择乙方公示的资费方案,乙方公示的资费方案应有有效截止期。
            br
            | 4.2&nbsp;如无特殊约定，甲方在资费方案有效期内可更换乙方在售的其他资费方案。
            br
            | 4.3&nbsp;乙方有权在资费方案有效期截止后终止该资费方案。乙方如终止该资费方案，应当至少在有效期截止前30&nbsp;日通知甲方，并告知资费方案到期后甲方可选择终止服务或乙方在售的其他资费方案。
            br
            br
            | 第五条&nbsp;&nbsp;电信服务费用交纳
            br
            | 5.1&nbsp;甲方使用乙方提供的电信服务，应按照双方约定的时间、方式，向乙方足额交纳费用。
            br
            | 5.2&nbsp;甲方若为预付费用户，应保证账户上有充足的金额，当账户欠费时，乙方应短信或电话提醒甲方及时缴费，如甲方不及时缴费，乙方可限制或停止向甲方提供电信服务。
            br
            | 5.3&nbsp;甲方若为后付费用户，每月最后一日为上月费用的正常交费截止日，另有约定除外。如甲方逾期不交纳电信费用，乙方应短信或电话提醒甲方补交电信费用，并可根据《中华人民共和国电信条例》的相关规定暂停或限制甲方的电信服务。
            br
            | 5.4&nbsp;甲方逾期不交纳电信费用的，自约定的交费截止日的次日起，乙方可以按照所欠费用每日加收3‰（千分之三）的违约金，但违约金总额最高不得超过所欠费用的30%。因甲方欠费，乙方有权不为甲方开办其他业务。
            br
            | 5.5&nbsp;甲方如选择银行托收、代扣等方式支付电信费用的，需到银行等机构办理相应手续；甲方不再使用乙方提供电信服务时，应自行前往银行，终止银行托收、代扣关系。
            br
            | 5.6&nbsp;乙方暂停或限制甲方的电信服务（以下简称“欠费停机”）之日起60&nbsp;日内，甲方补交电信费用、违约金后，乙方应当在24&nbsp;小时内恢复暂停的电信服务。欠费停机满60&nbsp;日，甲方仍未补交电信费用和违约金的，乙方有权终止提供电信服务、收回号码、撤销账号，通过信函、通告、委托第三方等方式追缴全部欠费和违约金，并可按有关规定向征信机构提供甲方欠费信息记录。
            br
            | 5.7&nbsp;乙方对通信费原始数据保留期限至少5&nbsp;个月,&nbsp;乙方应当免费为甲方提供最近5&nbsp;个月的通信费详单查询服务。若甲方对乙方收费提出异议，应在异议费用发生后5&nbsp;个月内向乙方提出，在异议解决之前，乙方应当保存相关原始资料。
            br
            br
            | 第六条&nbsp;&nbsp;用户权益保障及隐私保护
            br
            | 6.1&nbsp;乙方在承诺的网络覆盖范围内按照不低于《电信服务规范》等标准向甲方提供服务。乙方负责其销售或出租网络、设备及终端的安装、调测和维护。
            br
            | 6.2&nbsp;未经甲方同意，乙方不得为甲方办理包括产品体验、免费试用等在内的各类电信业务。
            br
            | 6.3&nbsp;乙方收集、使用甲方个人信息，应当遵循合法、正当、必要的原则。相关部门依法对用户个人信息调查取证的，乙方有义务配合。
            br
            | 6.4&nbsp;乙方对用户资料和通信信息负有保密义务，因乙方责任导致用户资料和通信信息泄露的，乙方须承担相应法律责任。
            br
            br
            | 第七条&nbsp;&nbsp;风险与责任
            br
            | 7.1&nbsp;电信网码号资源属于国家所有。如因技术进步和行政区划调整等原因，电信管理机构需收回、调整电信网码号资源的，甲、乙双方均应按国家有关规定予以配合。
            br
            | 7.2&nbsp;甲方应妥善保管自己的终端、通信卡、服务密码、宽带账号密码等，若因自身原因发生丢失或被盗用，甲方应及时办理暂时停机手续或修改相关密码，并可向公安机关报案，乙方应积极配合，但不承担甲方因此产生的损失；甲方如将名下的通信卡、服务密码、宽带账号密码等交予他人使用，由此引起的义务与责任由甲方承担。
            br
            | 7.3&nbsp;服务密码是甲方办理业务的重要凭证。乙方建议甲方办理入网手续后，立即修改初始服务密码并妥善管理修改后服务密码。使用服务密码定制、变更或终止业务的行为被视为甲方或甲方授权的行为，因此引起的义务与责任由甲方承担。
            br
            | 7.4&nbsp;甲方入网时，如乙方利用收回的号码重新放号，应明确告知甲方，并提醒甲方可能存在有未解绑第三方应用等风险。
            br
            | 7.5&nbsp;无特殊约定，乙方可以对甲方的移动数据流量进行封顶限制。甲方每月的移动数据流量达到流量封顶额度时，乙方应短信或电话提醒甲方，并可限制甲方当月的上网服务，次月自动恢复。
            br
            | 7.6&nbsp;甲方利用所使用的号码与第三方应用进行绑定的行为是甲方与第三方之间自愿建立的合同关系。甲方在办理销户/过户时应自行对所销户/过户的号码绑定的第三方应用进行解绑，如未解绑造成的隐私泄露或个人财产损失，甲方自行承担责任。
            br
            | 7.7&nbsp;乙方根据现有技术条件为用户提供便捷、安全的电信服务，除法律另有规定外，乙方不对用户的通信内容负责。甲方应对通信内容（来电、短信、邮件等）中涉及财物、资金事项予以审慎鉴别，对以乙方名义的来电、短信等通知，应当拨打乙方客服热线或到当地乙方自有营业网点进行核实。
            br
            | 7.8&nbsp;甲方违法违规使用电信业务，或使用电信业务侵犯他人合法权益的，由甲方承担责任。
            br
            | 7.9&nbsp;乙方发现甲方冒用或伪造身份证照、违法使用、违规外呼、呼叫频次异常、超约定用途使用、转租转售、被公安机关通报以及用户就上述问题投诉较多等情况的，核实确认后，乙方将终止甲方业务接入。
            br
            br
            | 第八条&nbsp;&nbsp;违约责任
            br
            | 8.1&nbsp;一方违约给对方造成损失的，应当依法承担赔偿责任。
            br
            | 8.2&nbsp;一方因自然灾害、战争等不可抗力原因和政府行为不能履行协议的，根据不可抗力的影响，部分或者全部免除责任，但法律另有规定的除外。一方迟延履约后发生不可抗力的，不能免除其责任。
            br
            br
            | 第九条&nbsp;&nbsp;协议的补充、变更、终止
            br
            | 9.1&nbsp;本协议执行过程中，经甲、乙双方同意，可以对协议进行修订或补充，由此形成的补充协议，与本协议具有相同法律效力。
            br
            | 9.2&nbsp;甲方可以持登记的有效证件原件到乙方指定营业网点办理销户手续。除双方另有约定外，乙方不得拒绝。甲方应在销户前结清所有费用，如甲方使用的终端设备产权归属乙方，须将完好的设备归还乙方。乙方应为甲方办理销户手续提供便利条件。
            br
            | 9.3&nbsp;甲方销户时，乙方应按甲方要求将账户余额一次性转入甲方在乙方的其他有效账户中，其中现金缴费的可以现金退还甲方。甲方接受乙方赠送、享受销售优惠或双方另有其他约定的除外。
            br
            | 9.4&nbsp;经乙方同意，甲方将本协议涉及的号码或账号过户给第三方时，甲方和第三方均应持有效身份证件原件到乙方指定营业网点办理手续，第三方如需变更资费方案，须重新选择乙方当期在售的资费方案。
            br
            | 9.4.1&nbsp;甲方在过户前须结清电信费用或与第三方签订相关电信费用承担协议，甲方过户前的积分、促销电子券等权益由甲方自行处理。
            br
            | 9.4.2&nbsp;过户手续办理完毕后，本协议终止，乙方不再向甲方提供查询、打印过户前通话清单、账单的服务。
            br
            | 9.5&nbsp;有下列情形之一的，乙方有权限制、暂停、终止通信服务，收回号码或账号，并保留追究甲方违约责任的权利：
            br
            | (1）违反国家法律、法规和相关政策规定，利用乙方提供的网络资源传播非法信息的；
            br
            | (2）未经电子信息接收者同意或请求，或者电子信息接收者明确表示拒绝的，仍向其固定电话、移动电话或者个人电子邮箱发送商业性电子信息的；
            br
            | (3）甲方的号码或账号等被有关机关认定用于违法犯罪活动或其他不正当用途的；
            br
            | (4）甲方违反实名登记规定的；
            br
            | (5）甲方自行安装使用未取得国家入网许可设备的；
            br
            | (6）甲方擅自改变电信业务使用性质或未经乙方同意将乙方提供的各类资源和服务转租（售）的；
            br
            | (7）法律、法规规定的其他情形。
            br
            br
            | 第十条&nbsp;&nbsp;协议生效
            br
            | 本协议一式两份，甲乙双方各执一份，自双方签字或盖章之日起生效。甲方如需终止本协议，须办理销户手续，自办理之日起，本协议自动终止。除甲方违反本协议5.6、9.5&nbsp;的相关条款外，乙方不得无故终止本协议。如因乙方电信业务经营许可证的业务范围、业务种类发生改变，或由于技术进步，无法向甲方提供原有的业务时，乙方可与甲方协商终止本协议，并应为甲方提供合理的替代解决方案。
            br
            br
            | 第十一条&nbsp;&nbsp;争议解决
            br
            | 所有因本协议引起的或与本协议有关的争议，本着互让互利的原则，通过协商解决,也可由当地有关部门调解，协商或调解不成的，双方也可采取以下第（&nbsp;）方式解决争议：（1）向[&nbsp;]仲裁委员会申请仲裁裁决；（2）向[&nbsp;]人民法院起诉。
            br
            br
    el-dialog.mobile-selector(title="请点选喜欢的号码", :visible.sync="isMobileSelectorShow", width="90%")
      //- el-input.search-area(placeholder="请输入想要的数字", clearable, v-model="mobileSearch.searchKey")
      //-   el-button(@click="queryMobile(1)" slot="append" icon="el-icon-search")
      ul.mobile-pool(v-if="mobilePool && mobilePool.length > 0")
        li(v-for="item in mobilePool", :key="item.access_number", @click="selectedMobile(item.access_number)") {{item.access_number}}
      el-alert(v-else, type="info", title="没有可以选择的号码", :closable="false")
      div(slot="footer")
        //- el-button(@click="queryMobile(mobileSearch.page + 1)") 换一组
</template>

<script>
import MobileSelect from 'mobile-select'
// eslint-disable-next-line
const ID_REGEX = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/
export default {
  name: 'CardIndex',
  data() {
    return {
      isProtocolShow: false,
      agreeProtocol: true,
      mobilePool: [],
      isMobileSelectorShow: false,
      form: {
        receiverCityName: '',
        receiverTownName: '',
        receiverProvinceName: '新疆',
        receiverCityCode: '',
        receiverTownCode: '',
        receiverProvinceCode: '0900',
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        channel: null,
        cardNo: '',
        cardName: '',
        mobile: '',
        packageId: 2039,
        receiverName: '',
        receiverPhone: '',
        receiverAdd: '',
      },
      areaText: '',
      loading: false,
      mobileSearch: {
        page: 1,
        limit: 10,
        searchKey: ''
      },
      carrierId: 13,
      areaSelector: null,
      cityOpts: [],
      lastCityCode: ''
    }
  },
  mounted() {
    this.$service.CardService
      .queryXJOrderArea()
      .then(res => {
        if (res.data.success) {
          res.data.sub_data.forEach(city => {
            let _city = {
              id: city.city_code,
              name: city.city_name,
              children: [
                {
                  id: '',
                  name: '-'
                }
              ]
            }
            this.cityOpts.push(_city)
          })
          this.areaSelector = new MobileSelect({
            trigger: "#areaSelector",
            title: "请选择收货地区",
            wheels: [
              {
                data: this.cityOpts
              }
            ],
            keyMap: {
              id:'id',
              value: 'name',
              childs :'children'
            },
            callback: (indexArr, data) => {
              this.form.receiverCityName = data[0].name
              this.form.receiverCityCode = data[0].id
              this.form.receiverTownName = data[1].name
              this.form.receiverTownCode = data[1].id
              this.areaText = '新疆' + this.form.receiverCityName + this.form.receiverTownName
              if (window._czc) {
                window._czc.push(['_trackEvent', '新疆', '选择收获省市区县', '360G/年号卡', 1, '成功'])
              }
              this.queryMobile(1)
            },
            transitionEnd: (indexArr, data) => {
              if (this.lastCityCode != data[0].id) {
                this.queryTown(data[0].id, indexArr[0])
              }
            }
          });
          this.queryTown(this.cityOpts[0].id, 0)
        } else {
          this.$message({
            type: 'warning',
            message: res.data.message
          })
        }
      })
  },
  methods: {
    goBack() {
      window.history.go(-1)
    },
    queryTown(cityCode, cityIndex) {
      this.lastCityCode = cityCode
      this.$service.CardService
        .queryXJOrderArea({
          areaCode: cityCode
        })
        .then(res => {
          if (res.data.success) {
            let _townOpts = []
            res.data.sub_data.forEach(item => {
              _townOpts.push({
                id: item.area_code,
                name: item.area_name
              })
            })
            this.cityOpts[cityIndex].children = _townOpts
            this.areaSelector.updateWheels(this.cityOpts)
            this.areaSelector.locatePosition(0, cityIndex);
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
    },
    showMobileSelector() {
      if (this.mobilePool && this.mobilePool.length > 0) {
        this.isMobileSelectorShow = true
      } else if (!this.form.receiverProvinceCode) {
        this.$message({
          type: 'warning',
          message: '请先选择收货地区'
        })
      } else {
        this.$message({
          type: 'warning',
          message: '没有可选号码'
        })
      }
    },
    queryMobile(page) {
      this.mobileSearch.page = page || this.mobileSearch.page
      this.$service.CardService
        .queryXJNumberPool({
          areaCode: this.form.receiverCityCode,
          carrierId: this.carrierId,
          startNum: 1,
          endNum: 1
        })
        .then(res => {
          this.form.mobile = res.data.sub_data.number_info[Math.floor(Math.random() * res.data.sub_data.number_info.length)].access_number
          this.mobilePool = res.data.sub_data.number_info
          if (window._czc) {
            window._czc.push(['_trackEvent', '新疆', '自动选择号码', '360G/年号卡', 1, '成功'])
          }
        })
    },
    selectedMobile(mobile) {
      this.form.mobile = mobile
      this.mobileSearch.searchKey = ''
      this.isMobileSelectorShow = false
    },
    handelSubmit() {
      if (!this.agreeProtocol) {
        this.$message({
          type: 'warning',
          message: '请阅读入网协议，并同意协议内容'
        })
        return;
      }
      this.form.receiverName = this.form.cardName.replace(/\s/g, '')
      this.form.receiverPhone = this.form.receiverPhone.trim()
      this.form.provinceCode = this.form.receiverProvinceCode
      this.form.cityCode = this.form.receiverCityCode
      this.form.provinceName = this.form.receiverProvinceName
      this.form.cityName = this.form.receiverCityName
      this.form.receiverAdd = this.form.receiverAdd.replace(/\s/g, '')
      this.form.cardNo = this.form.cardNo.replace(/\s/g, '').replace('Ｘ', 'x')
      if(!this.$REGEX.mobile.test(this.form.receiverPhone)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      if(!this.form.cardName){
        this.$message.warning('请先输入身份证姓名')
        return;
      }
      if(!this.form.cardNo){
        this.$message.warning('请先输入身份证号')
        return;
      }
      if(!ID_REGEX.test(this.form.cardNo)) {
        this.$message.warning('请输入正确的身份证号')
        return;
      }
      if(!this.form.receiverProvinceCode){
        this.$message.warning('请选择收货省份')
        return;
      }
      if(!(this.form.receiverCityCode)){
        this.$message.warning('请选择收货市/区县')
        return;
      }
      if(!this.form.receiverAdd){
        this.$message.warning('请输入收货地址')
        return;
      }
      if(!this.form.mobile){
        this.$message.warning('当前地区没有可用的号码')
        return;
      }
      var _formdata = new FormData();
          _formdata.append('cardNo ', this.form.cardNo);
          _formdata.append('custName', this.form.cardName);
          _formdata.append('ascriptionCode', this.form.receiverCityCode);
          _formdata.append('mobile', this.form.mobile);
          _formdata.append('carrierId', this.carrierId);
          _formdata.append('packageId', this.form.packageId);
          _formdata.append('receiverName',this.form.cardName);//联系人
          _formdata.append('receiverPhone',this.form.receiverPhone);//联系电话
          _formdata.append('receiverProvinceName', this.form.receiverProvinceName);//省
          _formdata.append('receiverProvinceCode', this.form.receiverProvinceCode);//省
          _formdata.append('receiverCityName', this.form.receiverCityName);//市
          _formdata.append('receiverCityCode', this.form.receiverCityCode);//市
          _formdata.append('receiverTownName', this.form.receiverTownName);//区、县
          _formdata.append('receiverTownCode', this.form.receiverTownCode);//区、县
          _formdata.append('receiverAdd', this.form.receiverAdd);//地址
          _formdata.append('zipCode', '');//邮政编码
      let _loading = this.$loading({
        lock: true,
        text: '正在办理业务',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CardService
        .createXJOrder(_formdata)
        .then(res => {
          if (res.data.success) {
            if (window._czc) {
              window._czc.push(['_trackEvent', '新疆', '提交表单', '360G/年号卡', 1, '成功'])
            }
            if (window.countLog) {
              window.countLog.ready(function() {
                window.countLog.init(function() { 
                }, {
                  isCopy: 0,
                  pageType: 0 
                })
              })
            }
            this.$message({
              type: 'success',
              message: '办理成功'
            })
            this.$router.push({
              name: 'xjCardSuccess',
              query: this.$route.query.mod == '1' ? {
                mobile: this.form.mobile
              } : undefined
            })
          } else {
            if (window._czc) {
              window._czc.push(['_trackEvent', '新疆', '提交表单', '360G/年号卡', 0, '失败'])
            }
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          if (window._czc) {
            window._czc.push(['_trackEvent', '新疆', '提交表单', '360G/年号卡', 0, '失败'])
          }
          this.$message({
            type: 'error',
            message: '办理失败，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    }
  }
}
</script>

<style lang="less" scoped>
.common-header{
  height: 3rem;
  line-height: 3rem;
  padding: 0 0.14rem;
  img {
    padding: .5rem 0;
    margin-left: 1rem;
    width: 2rem;
    height: 2rem;
  }
  .title {
    text-align: center;
    font-size: 1.1rem;
  }
  &.iphone {
    /* ios状态栏设置20px空白，解决ios标题栏 */
    height: 3.2rem;
    padding: 1.5rem 0.14rem 0;

    .back::before {
      margin-top: 0.06rem;
    }
  }
  &.isIphoneX {
    height: 3.4rem;
    padding: 1.5rem 0.14rem 0;
  }
}
.card-index{
  // background: url('../../../assets/images/card/bg.jpg') repeat;
  background-color: #312E2F;
  padding-bottom: 1rem;
  .header, .body{
    img{
      width: 100%;
    }
    .card-notice{
      background-color: #171715;
      width: 100%;
      margin: 0 auto;
      border-radius: 12px;
      margin-top: 1rem;
      text-align: center;
      img{
        width: 100%;
      }
      >ol{
        text-align: left;
        color: #a3a3a3;
        padding: 24px;
        list-style-type: decimal;
        >li{
          // border-bottom: 1px dashed #a3a3a3;
          padding: 12px 0;
        }
      }
    }
  }
}
.form-area{
  width: 80%;
  margin: 0 auto 1rem auto;
  background-color: #B28850;
  padding: 1rem;
  border-radius: 6px;
}
.el-form-item{
  margin-bottom: .2rem;
  text-align: center;
  .btn-submit{
    margin-top: 1rem;
    width: 90%;
    color: rgb(152,90,18);
    background: #F5D79B;
    font-size: 1rem;
    font-weight: bold;
    border-radius: 12px;
  }
}
.protocol-content{
  height: 70vh;
  overflow: auto;
}
.search-area{
  margin-bottom: 1rem;
}
.mobile-pool{
  zoom: 1;
  clear: both;
  overflow: hidden;
  font-size: 1.2rem;
  width: 100%;
  padding-left: 1rem;
  color: rgb(152,90,18);
  >li{
    float: left;
    width: 9rem;
    padding: .5rem 0;
  }
}
</style>